import { imageCache } from "./imageCache";
import { downscaleWithBitmap } from "./imageResizer";

export async function getProcessedImage(imagePath: string) {
    const existing = imageCache.get(imagePath);

    if (existing && !(existing instanceof Promise)) {
        return existing.url;
    }

    if (existing instanceof Promise) {
        return (await existing).url;
    }

    const downloadPromise = (async () => {
        const url = await downscaleWithBitmap(imagePath, 216, 144);
        const result = { url: url as string };
        imageCache.set(imagePath, result);
        return result;
    })();

    imageCache.set(imagePath, downloadPromise);

    const resolved = await downloadPromise;
    return resolved.url;
}
